import { render, staticRenderFns } from "./BronzeCourt.vue?vue&type=template&id=017a2ced&scoped=true"
import script from "./BronzeCourt.vue?vue&type=script&lang=js"
export * from "./BronzeCourt.vue?vue&type=script&lang=js"
import style0 from "./BronzeCourt.vue?vue&type=style&index=0&id=017a2ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017a2ced",
  null
  
)

export default component.exports